import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faGift, faChevronRight, faComments } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { isSuperAdmin } from "../../utils/roles";
import "./adminTabs.css";

/**
 * Shared admin section navigation, rendered as a stacked list of menu rows at
 * the top of each admin page's body. The current section is highlighted.
 * Sections flagged superAdminOnly only render for the top-tier owner account.
 */
const SECTIONS = [
  { to: "/admin", label: "Manage Users", icon: faUsers },
  { to: "/admin/referrals", label: "Referrals", icon: faGift, superAdminOnly: true },
  { to: "/admin/claims", label: "WhatsApp Claims", icon: faWhatsapp, superAdminOnly: true },
  { to: "/admin/messages", label: "WhatsApp Feed", icon: faComments, superAdminOnly: true },
];

const AdminNav = ({ loginUser }) => {
  const { pathname } = useLocation();
  const sections = SECTIONS.filter(
    (section) => !section.superAdminOnly || isSuperAdmin(loginUser)
  );

  return (
    <nav className="sr-admin-nav">
      {sections.map((section) => {
        const active = pathname === section.to;
        return (
          <Link
            key={section.to}
            to={section.to}
            className={`sr-admin-nav__row ${active ? "sr-admin-nav__row--active" : ""}`}
            aria-current={active ? "page" : undefined}
          >
            <span className="sr-admin-nav__icon">
              <FontAwesomeIcon icon={section.icon} />
            </span>
            <span className="sr-admin-nav__label">{section.label}</span>
            <FontAwesomeIcon icon={faChevronRight} className="sr-admin-nav__chevron" />
          </Link>
        );
      })}
    </nav>
  );
};

export default AdminNav;
